import { Drawer } from "@mui/material";
import "./SessionClosingDrawerV2.css";
import { lazy, Suspense, useEffect, useState } from "react";
import PosPageLoader from "../../../../../customComponents/PosPageLoader/PosPageLoader";

const SESSION_CLOSING_PAGES = {
  // <CartConfig /> -- component
  SESSION_HOME_PAGE: {
    component: lazy(() => import("../SessionClosingDrawer/SessionCLosingDrawer.js")),
    // header: "",
    // subHeader: "",
  },
  COD_SETTLEMENT_PAGE: {
    component: lazy(() => import("./Component/CODSettlement/CODSettlement.js")),
    // header: "",
    // subHeader: "",
  },
  DENOMINATION_PAGE: {
    component: lazy(() => import("./Component/DenominationSessionV3/DenominationSessionV3.js")),
    // header: "",
    // subHeader: "",
  },

  SESSION_STATEMENT: {
    component: lazy(() => import("./Component/SessionStatementV3/SessionStatementV3.js")),
    // header: "",
    // subHeader: "",
  },

  SESSION_CLOSING_PAGE: {
    component: lazy(() => import("../../../product/sessionPage/components/DayClosing")),
  },

  END_OF_DAY_SUMMARY_PAGE: {
    component: lazy(() => import("./Component/EndOfDaySummary/EndOfDaySummary.js")),
  },

  END_DAY_CLOSING_PAGE: {
    component: lazy(() => import("../../../EndDayStockCount")),
  },
};

const SessionClosingDrawerV2 = ({ open, onClose }) => {
  const [pageStack, setPageStack] = useState([{ page: "SESSION_HOME_PAGE", data: null }]);

  useEffect(() => {
    if (open) {
      setPageStack([{ page: "SESSION_HOME_PAGE", data: null }]);
    }
  }, [open]);

  //   --------------------for navigate next and back -------------

  const navigate = (page, data = null) => {
    setPageStack((prev) => [...prev, { page, data }]);
  };

  // go back
  const goBack = () => {
    setPageStack((prev) => prev.slice(0, -1));
  };

  //   define the current page and current component --------------------
  const currentPageObj = pageStack[pageStack?.length - 1];
  const currentPage = currentPageObj?.page;
  const pageData = currentPageObj?.data;

  const CurrentPageConfig = SESSION_CLOSING_PAGES[currentPage];

  const CurrentComponent = CurrentPageConfig?.component;
  const header = pageData?.header || CurrentPageConfig?.header;
  const subHeader = pageData?.subHeader || CurrentPageConfig?.subHeader;

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      //   PaperProps={{ className: "session-drawer-paper" }}
    >
      <main className="session-closing-main-container">
        {/* navbar */}
        <div className="session-closing-body-wrapper">
          {/* <NavBar
            headder={header}
            subHeadder={subHeader}
            canGoBack={pageStack?.length > 1}
            onBack={goBack}
            onClose={onClose}
          /> */}

          {/* session components */}
          <Suspense fallback={<PosPageLoader />}>
            <CurrentComponent navigate={navigate} {...(pageData || {})} onClose={onClose} />
          </Suspense>

          {/* footer section */}
        </div>
      </main>
    </Drawer>
  );
};

export default SessionClosingDrawerV2;
